// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my_divider[data-v-72b74919]{border:3px solid;border-radius:2px;max-width:5rem;width:40px}.fixed-width-chip[data-v-72b74919]{width:100%}.fixed-title-chip[data-v-72b74919]{width:150px}", ""]);
// Exports
module.exports = exports;
